<template>
    <div>
        <registration-layout :loanPossibility="loanPossibility">
            <v-card-text class="registration-card">
                <v-row>
                    <v-col>
                        <div class="title text--thin text-center">
                            {{ $t("for_email_verificcation") }}
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
        </registration-layout>

        <v-row align="center" justify="center">
            <v-col cols="12" lg="8" md="8" sm="8">
                <v-card>
                    <v-container fluid>
                        <v-row align="center" justify="center">
                            <v-col cols="12" lg="8" md="8" sm="8">
                                <div class="text-center">
                                    {{ $t("for_verification_plese_confirm_email") }}
                                </div>
                                <div class="text-center">
                                    <v-text-field
                                        class="font-weight-bold"
                                        :append-icon="
                                            editEmail ? 'mdi-email-edit' : 'mdi-content-save'
                                        "
                                        @click:append="changeEmail"
                                        :solo="editEmail"
                                        flat
                                        dense
                                        :disabled="!canResend"
                                        :readonly="editEmail"
                                        v-model="user.email"
                                        color="primary"
                                        required
                                    ></v-text-field>
                                </div>
                            </v-col>
                            <v-col>
                                <div class="text-center">
                                    <v-btn
                                        x-large
                                        color="primary"
                                        @click="toMail(user.email)"
                                        :disabled="!editEmail"
                                        >{{ $t("to_email") }}
                                    </v-btn>
                                    <v-btn
                                        large
                                        text
                                        depressed
                                        color="primary"
                                        @click="sendEmail"
                                        :disabled="!canResend"
                                    >
                                        {{ $t("send_again") }}
                                        <countdown
                                            v-if="!canResend"
                                            :time="90 * 1000"
                                            @end="makeAvailableResend"
                                        >
                                            <template slot-scope="props">
                                                <span v-show="!canResend"
                                                    >({{ props.minutes }}:{{
                                                        parseInt(props.seconds) < 10
                                                            ? "0" + props.seconds
                                                            : props.seconds
                                                    }})</span
                                                >
                                            </template>
                                        </countdown>
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
                <br />
                <v-card v-show="!app_settings.is_email_required">
                    <v-row align="center" justify="center">
                        <v-col cols="12" align="center" justify="center">
                            <v-btn text depressed small color="primary" @click="nextStage()">
                                <span class="font-weight-bold">{{ $t("verify_later") }}</span>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import VueCountdown from "@chenfengyuan/vue-countdown";

import RegistrationLayout from "@/app/mobile/registration/shared/components/Layout";

export default {
    name: "RegFirstStep",
    components: {
        countdown: VueCountdown,
        RegistrationLayout,
    },
    data() {
        return {
            snackbar: false,
            canResend: false,
            editEmail: true,
            emailSended: false,
            emailIcon: "mdi-email-edit",
        };
    },
    created() {
        this.sendEmail();
    },
    methods: {
        changeEmail() {
            if (!this.editEmail) {
                this.$toast.success(this.$t("we_sent_mail_to_you", { email: this.user.email }));
                this.editEmail = true;
                this.sendEmail();
            } else {
                this.editEmail = false;
            }
        },
        sendEmail() {
            this.$store
                .dispatch("SEND_EMAIL_VERIFICATION_CODE")
                .then(() => {
                    this.$toast.success(
                        this.$t("we_sent_mail_to_your_email_register", { email: this.user.email })
                    );
                    this.isCodeResend = true;
                })
                .catch((error) => {
                    const exception = error.response.data.exception;
                    switch (exception) {
                        case "VerificationCodeAlreadySentException":
                            this.$toast.warning(
                                this.$t(`exception.${exception}`, { type: "Email" })
                            );
                            break;
                        default:
                            this.$toast.error(this.$t("errors.we_cant_send_email"));
                            break;
                    }
                });
            this.canResend = false;
        },
        makeAvailableResend() {
            this.canResend = true;
        },
        toMail(email) {
            const mailSite = email.split("@")[1];
            window.open(`http://${mailSite}`, "_blank");
            this.emailSended = !this.emailSended;
        },
        nextStage() {
            this.$router.push({
                path: `/check-requisites?api_key=${this.$store.getters.GET_REGISTRATED_USER_APIKEY}`,
            });
        },
    },
    computed: {
        loanPossibility() {
            return this.$store.getters.LOAN_POSSIBILITY;
        },
        user() {
            return this.$store.getters.GET_REGISTRATED_USER;
        },
        app_settings() {
            return this.$store.getters.APP_SETTINGS;
        },
    },
};
</script>
